/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_P1Inputs */

const en_fc_home_artcraft_p1 = /** @type {(inputs: Fc_Home_Artcraft_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft is one app in ArtCraft, a growing suite of free, open-source alternatives to professional creative software. Each Crafting App targets a familiar tool: PhotoCraft for photo editing, VectorCraft for illustration, PdfCraft for documents and FilmCraft for video. EffectCraft, LightCraft, SoundCraft and DeckCraft round out the family.`)
};

/**
* | output |
* | --- |
* | "FilmCraft is one app in ArtCraft, a growing suite of free, open-source alternatives to professional creative software. Each Crafting App targets a familiar t..." |
*
* @param {Fc_Home_Artcraft_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_p1 = /** @type {((inputs?: Fc_Home_Artcraft_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_p1(inputs)
});
export { fc_home_artcraft_p1 as "fc.home.artcraft.p1" }